import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { bindPropStore } from "../bindProps";
import { emit, label as runtimeLabel, text } from "../helpers";
import InlineIcon from "../InlineIcon.svelte";
import { resolveIconWeight } from "../../../icons/manager";

var root = $.from_html(`<span class="slex-sr-only"> </span>`);
var root_1 = $.from_html(`<a><!> <!></a>`);
var root_2 = $.from_html(`<button type="button"><!> <!></button>`);

export default function Button($$anchor, $$props) {
	$.push($$props, true);

	let p = $.state($.proxy({}));

	$.user_effect(() => bindPropStore($$props.props, (next) => $.set(p, next, true)));

	function variant() {
		const kind = text($.get(p).type ?? $.get(p).variant ?? "primary");

		if (kind === "destructive") return "danger";
		if (kind === "default") return "primary";

		return kind;
	}

	function selected() {
		return resolveIconWeight({
			selected: $.get(p).selected,
			active: $.get(p).active,
			pressed: $.get(p).pressed
		}) === "duotone";
	}

	function iconOnly() {
		return !!($.get(p).iconOnly || $.get(p).icon && !$.get(p).label);
	}

	function label() {
		return runtimeLabel($$props.ctx, "button.label", $.get(p).label ?? $.get(p).title ?? $.get(p)["aria-label"] ?? $.get(p).ariaLabel, $$props.componentName);
	}

	function click(event) {
		if ($.get(p).disabled) return;

		emit($$props.ctx, "click", { type: "click", target: $$props.ctx.id, native: event });
	}

	var fragment = $.comment();
	var node = $.first_child(fragment);

	{
		var consequent_2 = ($$anchor) => {
			var a = root_1();
			var node_1 = $.child(a);

			{
				var consequent = ($$anchor) => {
					InlineIcon($$anchor, {
						get name() {
							return $.get(p).icon;
						},

						get active() {
							return $.get(p).active;
						},

						get selected() {
							return $.get(p).selected;
						},

						get pressed() {
							return $.get(p).pressed;
						},
						className: 'slex-button-icon'
					});
				};

				$.if(node_1, ($$render) => {
					if ($.get(p).icon) $$render(consequent);
				});
			}

			var node_2 = $.sibling(node_1, 2);

			{
				var consequent_1 = ($$anchor) => {
					var span = root();
					var text_1 = $.child(span, true);

					$.reset(span);
					$.template_effect(($0) => $.set_text(text_1, $0), [() => label()]);
					$.append($$anchor, span);
				};

				var d = $.derived(() => iconOnly());

				var alternate = ($$anchor) => {
					var text_2 = $.text();

					$.template_effect(($0) => $.set_text(text_2, $0), [() => label()]);
					$.append($$anchor, text_2);
				};

				$.if(node_2, ($$render) => {
					if ($.get(d)) $$render(consequent_1); else $$render(alternate, -1);
				});
			}

			$.reset(a);

			$.template_effect(
				($0, $1, $2, $3, $4, $5, $6) => {
					$.set_class(a, 1, $0);
					$.set_attribute(a, 'href', $1);
					$.set_attribute(a, 'target', $2);
					$.set_attribute(a, 'rel', $.get(p).target === "_blank" ? "noreferrer" : undefined);
					$.set_attribute(a, 'aria-disabled', $.get(p).disabled ? "true" : undefined);
					$.set_attribute(a, 'data-selected', $3);
					$.set_attribute(a, 'aria-pressed', $4);
					$.set_attribute(a, 'title', $5);
					$.set_attribute(a, 'aria-label', $6);
				},
				[
					() => `slex-button slex-button--${variant()} ${iconOnly() ? "slex-button--icon" : ""} ${$.get(p).disabled ? "slex-button--disabled" : ""}`,
					() => $.get(p).disabled ? undefined : text($.get(p).href),
					() => text($.get(p).target) || undefined,
					() => selected() ? "" : undefined,
					() => $.get(p).pressed === undefined ? undefined : selected(),
					() => text($.get(p).title ?? $.get(p).label),
					() => text($.get(p)["aria-label"] ?? $.get(p).ariaLabel ?? $.get(p).title ?? $.get(p).label) || undefined
				]
			);

			$.append($$anchor, a);
		};

		var alternate_2 = ($$anchor) => {
			var button = root_2();
			var node_3 = $.child(button);

			{
				var consequent_3 = ($$anchor) => {
					InlineIcon($$anchor, {
						get name() {
							return $.get(p).icon;
						},

						get active() {
							return $.get(p).active;
						},

						get selected() {
							return $.get(p).selected;
						},

						get pressed() {
							return $.get(p).pressed;
						},
						className: 'slex-button-icon'
					});
				};

				$.if(node_3, ($$render) => {
					if ($.get(p).icon) $$render(consequent_3);
				});
			}

			var node_4 = $.sibling(node_3, 2);

			{
				var consequent_4 = ($$anchor) => {
					var span_1 = root();
					var text_3 = $.child(span_1, true);

					$.reset(span_1);
					$.template_effect(($0) => $.set_text(text_3, $0), [() => label()]);
					$.append($$anchor, span_1);
				};

				var d_1 = $.derived(() => iconOnly());

				var alternate_1 = ($$anchor) => {
					var text_4 = $.text();

					$.template_effect(($0) => $.set_text(text_4, $0), [() => label()]);
					$.append($$anchor, text_4);
				};

				$.if(node_4, ($$render) => {
					if ($.get(d_1)) $$render(consequent_4); else $$render(alternate_1, -1);
				});
			}

			$.reset(button);

			$.template_effect(
				($0, $1, $2, $3, $4) => {
					$.set_class(button, 1, $0);
					button.disabled = !!$.get(p).disabled;
					$.set_attribute(button, 'data-selected', $1);
					$.set_attribute(button, 'aria-pressed', $2);
					$.set_attribute(button, 'title', $3);
					$.set_attribute(button, 'aria-label', $4);
				},
				[
					() => `slex-button slex-button--${variant()} ${iconOnly() ? "slex-button--icon" : ""}`,
					() => selected() ? "" : undefined,
					() => $.get(p).pressed === undefined ? undefined : selected(),
					() => text($.get(p).title ?? $.get(p).label),
					() => text($.get(p)["aria-label"] ?? $.get(p).ariaLabel ?? $.get(p).title ?? $.get(p).label) || undefined
				]
			);

			$.delegated('click', button, click);
			$.append($$anchor, button);
		};

		$.if(node, ($$render) => {
			if ($.get(p).href) $$render(consequent_2); else $$render(alternate_2, -1);
		});
	}

	$.append($$anchor, fragment);
	$.pop();
}

$.delegate(['click']);